import MediaBlock from '.';
import type { Meta, StoryObj } from '@storybook/vue3';
import { Default as Image } from 'ewi-ui/components/1-atoms/Media/Image/Image.stories.ts';
import {
  NativeUpload as VideoDialog,
  Youtube as YoutubeVideoDialog,
} from 'ewi-ui/components/2-molecules/VideoDialog/VideoDialog.stories';

const meta = {
  title: 'Molecules/MediaBlock',
  component: MediaBlock,
  render: (args, { globals }) => ({
    components: { MediaBlock },
    setup() {
      return { args, globals };
    },
    template: '<mediaBlock v-bind="args">{{ args.default }}</mediaBlock>',
  }),
  tags: ['autodocs'],
  argTypes: {
    background: {
      control: 'select',
      options: ['', 'light', 'lightgrey'],
    },
    bodyText: {
      control: 'text',
    },
    firstButtonContent: {
      control: 'text',
    },
    firstButtonInNewWindow: {
      control: 'boolean',
    },
    secondButtonContent: {
      control: 'text',
    },
    imagePosition: {
      control: 'select',
      options: ['left', 'right'],
    },
  },
  args: {
    background: '',
    bodyText:
      '<h2>Ökostrom und Gas vom Energieanbieter</h2><p>Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem Gas kennen.</p>',
    firstButtonContent: 'Mehr Informationen',
    secondButtonContent: 'enabled',
    ...Image.args,
  },
} satisfies Meta<typeof MediaBlock>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  ...meta,
  args: {
    ...meta.args,
  },
};

export const Light: Story = {
  ...meta,
  args: {
    ...meta.args,
    background: 'light',
    firstButtonContent: 'Mehr Informationen',
    imageForceAspectRatio: '1_1',
  },
};
export const WithVideoNative: Story = {
  ...meta,
  args: {
    ...meta.args,
    videoDialog: VideoDialog.args,
  },
};

export const WithVideoYoutube: Story = {
  ...meta,
  args: {
    ...meta.args,
    videoDialog: YoutubeVideoDialog.args,
  },
};
